import SortShuterCytiPortal from './component'

export default SortShuterCytiPortal
